import { Component, Input, OnInit } from '@angular/core';
import { Cutting } from 'src/app/models/configurators-2d/applications/workbench/cutting';
import { WorkbenchService } from 'src/app/services/configurators-2d/applications/workbench.service';
import { Configurators2DComponent } from '../../../configurators-2d.component';
import { IWorkbenchPreview } from '../../preview/i-workbench-preview';
import { ConfigurationPlan } from 'src/app/models/configurators-2d/applications/workbench/configurations/configuration-plan';
import { WorkbenchConfiguratorItem } from '../../../configurator/applications/workbench-configurator-item';
import { ConfigurationCutting } from 'src/app/models/configurators-2d/applications/workbench/configurations/configuration-cutting';
import { Point } from 'src/app/models/configurators-2d/applications/workbench/utils/point';

@Component({
  selector: 'ng-workbench-plan-cutting-infos',
  templateUrl: './plan-cutting-infos.component.html',
})
export class WorkbenchPlanCuttingInfosComponent extends WorkbenchConfiguratorItem implements OnInit {
  @Input() cuttings: Cutting[];

  selectedCutting: Cutting;

  index: number;
  plans: ConfigurationPlan[];
  selectedPlanIndex: number;
  selectedPlanCuttingIndex: number;

  preview: IWorkbenchPreview;

  constructor(
    public workbenchService: WorkbenchService,
    configurator2DComponent: Configurators2DComponent
  ) {
    super(workbenchService);
    this.preview = configurator2DComponent.preview as IWorkbenchPreview;
  }

  ngOnInit(): void {
    this.plans = this.configuration.workbenchConfigurationPlans;
  }

  /**
   * Ajout / Suppression des ouvertures.
   */
  addConfigurationCutting() {
    var plan = this.configuration.workbenchConfigurationPlans.find(p => p.displayOrder === this.selectedPlanIndex);
    if (!plan.configurationCuttings) {
      plan.configurationCuttings = [];
    }

    let displayOrder = plan.configurationCuttings?.length + 1;

    plan.configurationCuttings.push(new ConfigurationCutting(displayOrder));
    // On affiche la dernière box créé.
    this.selectedPlanCuttingIndex = displayOrder;
  }

  /**
   * Sélection de la découpe.
   */
  selectCutting(cutting: Cutting): void {
    let plan = this.configuration.workbenchConfigurationPlans.find(p => p.displayOrder === this.selectedPlanIndex);
    let planCutting = plan.configurationCuttings.find(c => c.displayOrder === this.selectedPlanCuttingIndex);
    planCutting.cuttingId = cutting.id;
    planCutting.cutting = cutting;

    // Default origin to plan center (in mm from bottom-left) if not already set
    if (!planCutting.origin) {
      planCutting.origin = new Point(plan.length / 2, plan.width / 2);
    }

    this.selectedCutting = cutting;
    this.preview.loadPlanCuttings?.();
  }

  deleteCutting(index: number) {
    let plan = this.configuration.workbenchConfigurationPlans.find(p => p.displayOrder === this.selectedPlanIndex);
    plan.configurationCuttings.splice(
      plan.configurationCuttings.findIndex(c => c.displayOrder === index + 1),
      1
    );
    // Re-index
    plan.configurationCuttings.forEach((c, i) => (c.displayOrder = i + 1));
    this.preview.loadPlanCuttings?.();
  }

  /**
   * Gestion des ouvertures.
   */

  isCuttingSelected(id: number) {
    return (
      this.configuration.workbenchConfigurationPlans
        .find(p => p.displayOrder === this.selectedPlanIndex)
        ?.configurationCuttings?.find(c => c.displayOrder === this.selectedPlanCuttingIndex)
        ?.cuttingId === id
    );
  }

  /**
   * Affichage des cards (plan / ouvertures)
   */
  toggleCuttingCollapse(displayOrder: number): void {
    this.selectedPlanCuttingIndex = displayOrder;
  }

  togglePlanCollapse(displayOrder: number): void {
    this.selectedPlanIndex = displayOrder;
  }
}
